import React from "react";
import { Slider, Typography } from "antd";

const { Text } = Typography;

/**
 * מד גרירה לחלוקת דמי טיפול: שמאלה למוביל, ימינה לסוכן.
 * הערך הוא אחוז הסוכן (0–100).
 */
export default function HandlingFeeSplitSlider({
  value = 100,
  onChange,
  onChangeComplete,
  disabled = false,
  size = "default",
}) {
  const agentPct = Math.max(0, Math.min(100, Number(value) || 0));
  const leadPct = Math.round((100 - agentPct) * 100) / 100;
  const compact = size === "small";

  return (
    <div
      className={`handling-fee-split-slider${compact ? " handling-fee-split-slider--compact" : ""}`}
      dir="ltr"
    >
      <div className="handling-fee-split-slider__labels">
        <Text type="secondary" className="handling-fee-split-slider__lead">
          מוביל {leadPct}%
        </Text>
        <Text strong className="handling-fee-split-slider__agent">
          סוכן {agentPct}%
        </Text>
      </div>
      <Slider
        min={0}
        max={100}
        step={1}
        value={agentPct}
        disabled={disabled}
        tooltip={{ formatter: (v) => `סוכן ${v}% · מוביל ${100 - Number(v || 0)}%` }}
        onChange={onChange}
        onChangeComplete={onChangeComplete}
      />
    </div>
  );
}
